import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {Gatekeeper} from './shared/guards/gatekeeper.guard';
import {AuthenticatedWrapperComponent} from './components/authenticated/authenticated-wrapper/authenticated-wrapper.component';
import {LoginRoutes} from './components/public/login/login.routes';
import {LogoutRoutes} from './components/public/logout/logout.routes';
import {PublicWrapperComponent} from './components/public/public-wrapper/public-wrapper.component';
import {NotFoundRoutes} from './components/public/not-found/not-found.routes';
import {HomeRoutes} from "./components/public/home/home.routes";
import {AboutRoutes} from "./components/public/about/about.routes";
import {ProjectsRoutes} from "./components/public/projects/projects.routes";
import {ContactRoutes} from "./components/public/contact/contact.routes";
import {CityTouchRoutes} from "./components/public/city-touch/city-touch.routes";


export const AuthenticatedRoutes = [];


export const PublicRoutes = [

    ...AboutRoutes,
    ...ProjectsRoutes,
    ...ContactRoutes,
    ...CityTouchRoutes,
    ...HomeRoutes,
    ...LoginRoutes,
    ...LogoutRoutes,

];

export const AppRoutes = [
    {path: '', redirectTo: 'home', pathMatch: 'full'},
    {
        path: '',
        component: PublicWrapperComponent,
        children: [
            ...PublicRoutes,
            ...NotFoundRoutes
        ],

    }

];


@NgModule({
    imports: [
        RouterModule.forChild(AppRoutes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/app-routing.module.ts